import React from 'react';
import FormItemEditorRenderForAutoLookup from './FormItemEditorRenderForAutoLookup';
require('../../styles/FormItemRender.css');
export default class FormItemEnumRenderForAutoLookup extends FormItemEditorRenderForAutoLookup
{
	constructor(props) {
		super(props);
	}
	
	getDisplay(_value)
	{
		if(_value == null || _value == undefined)
			_value = this.props.value;
		let _options = this.props.options;
		let _valueRender = _value;
		for(var i in _options)
		{
			var item = _options[i];
			if(item.value == _value)
			{
				_valueRender = item.label;
				break;
			}
		}
		return _valueRender;
	}

	render()
	{
		let _value = this.props.rowData[this.props.dataField];
		_value = this.getDisplay(_value);
		
		return(
			<div className="gongqi_render_select" style={{padding:'3px'}} ref={ node => this.componentLabel = node }>
				{_value}
			</div>
			
		);
	}
}


// WEBPACK FOOTER //
// ./src/formItem/renders/FormItemEnumRenderForAutoLookup.js